exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrapper--99mzW {\n  padding: 0 10px;\n  margin-top: 15px;\n}\n\n.cards--32GvC {\n  border-bottom: 1px solid #C0C0C0;\n  min-height: 400px;\n}\n", ""]);

// exports
exports.locals = {
	"wrapper": "wrapper--99mzW",
	"cards": "cards--32GvC"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"minimize":false,"sourceMap":false,"localIdentName":"[local]--[hash:base64:5]","importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false,"plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js?{"data":"$env: production;","sourceMap":false,"outputStyle":"expanded","precision":10,"includePaths":["/app/node_modules","/app/src"]}!./src/containers/Private/pages/workflow-client/Emission/Cards/Cards.m.scss
// module id = 1422
// module chunks = 0